import React from "react";

const DateSelectField = ({ label = "Date", value, onChange }) => {
    return (
        <div className="inline-block w-56 text-left">
            <label className="mb-1 block text-sm font-medium text-gray-700">{label}</label>
            <input
                type="date"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="w-full rounded-md border border-gray-300 bg-white px-4 py-2 text-sm text-gray-700 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
        </div>
    );
};

export default DateSelectField;
